export const hostErrorMessage = 'is not a valid hostname for email address';

export const isHostnameError = (message: string | string[]): boolean => {
    if (typeof message === 'string') {
        return message.indexOf(hostErrorMessage) !== -1;
    }
    return message.some(part => part.indexOf(hostErrorMessage) !== -1);
};
